import React, { useEffect } from 'react';
import { Grid, Backdrop, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Form } from '@formio/react';
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import { properties as AppData } from 'AppData';
import { texts, objComponentFormio } from './altaUsuarioConContrasenaData';
import AltaUsuarioConContrasenaFunctions from './altaUsuarioConContrasenaFunctions';
import useStyles from './altaUsuarioConContrasenaStyle';
import './altaUsuarioConContrasenaStyle.css';
import 'BootstrapWrapper.scss';

export default function AltaUsuarioConContrasena() {
  const { style } = useStyles();
  const customStyle = style();
  const {
    handleOnSubmit,
    handleCustomEvents,
    isLoading,
    alerts,
    message,
    setMessage,
    loginAccess,
    mostrarConfirmacion,
    irAccesoConContraseña,
    formData,
    getResource,
    obtenerUrlContexto
  } = AltaUsuarioConContrasenaFunctions();

  // Se inserta el nombre del título de la página
  document.title = AppData.TITULO_PAGINA + texts.PAGE_TITLE;

  // Logamos la aplicación con el usuario usuario_acceso_ov con permisos para poder crear el usuario
  loginAccess();

  // Obtenemos el formulario en la carga inicial de la página
  useEffect(() => {
    getResource(objComponentFormio.aliasFormulario);
  }, []);

  return (
    <main>
      {/** El nombre de esta clase, tiene que coincidir con el nombre de la 
        * clase que se encuentra en el fichero BootstrapWrapper.scss */}
      <Grid className="componenteGenericoFormio">
        <Grid className={customStyle.gridTitulo}>
          <h2 className={customStyle.tituloPagina}>{texts.PAGE_TITLE}</h2>
        </Grid>
        <Grid className={customStyle.backgroundRectangle}>
        <Form
            form={formData}
            onSubmit={handleOnSubmit}
            options={{
                ov: true,
                language: 'sp',
                i18n: objComponentFormio.sp, 
                evalContext: {
                  // Funciones auxiliares
                  obtenerUrlContexto: obtenerUrlContexto
                },
            }}
            onCustomEvent={handleCustomEvents}
            //submission= {{ data: submissionData }}
        />
        </Grid>
      </Grid>
      <Backdrop className={customStyle.classBackdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {alerts.map((m) => (
        <Snackbar
          key="backdrop"
          open={message.msg}
          autoHideDuration={8000}
          onClose={() => setMessage({ severity: "", msg: "" })}
        >
          <Alert severity={message.severity} variant="filled">
            {message.msg}
          </Alert>
        </Snackbar>
      ))}
      <Confirmacion 
        mostrar={mostrarConfirmacion} isPhoneVersion={false}
        titulo={texts.confirmacion.titulo}
        mensaje={texts.confirmacion.mensaje}
        botonera='confirSoloAceptar'
        accionConfirmacion={irAccesoConContraseña}
        tamMarginTop='10'
        isPopUpPdf={false}
        textBotonConfirmarPersonalizado={false}
        isImagenPersonalizada={false}
        centrarContenido={true}
        isTextoEnriquecido={true}
      />
    </main>
  );
}
